const data = {
  atlas_bicycleParking: {
    keys: {
      stand_type: 'Aus `bicycle_parking=*`.',
      rental_type: 'Aus `bicycle_rental=*`.',
      geometry_transform:
        'Gesetzt, wenn ein OSM-Objekt nach Art aufgeteilt und die Lage der Teile geschätzt wurde.',
      mapillary: 'Mapillary-Foto-ID für dieses Feature.',
      traffic_sign: 'Verkehrszeichennummer, mit der dieses Feature ausgeschildert ist.',
    },
    values: {
      kind: {
        bicycle_parking: '`amenity=bicycle_parking`',
        cargo_bike_parking:
          '`amenity=bicycle_parking` mit `cargo_bike=designated` oder `capacity:cargo_bike`',
        small_electric_vehicle_parking:
          '`amenity=small_electric_vehicle_parking`, `amenity=kick-scooter_parking`',
        bicycle_rental: '`amenity=bicycle_rental`, ohne Fahrradverleih-Läden',
        mobility_hub:
          '`amenity=mobility_hub`. Eine Fläche, in der Stellplätze und Verleihstationen liegen; beim Summieren zählt sie nicht mit.',
      },
    },
  },
  atlas_bikelanes: {
    keys: {
      parent_road:
        'TILDA-Straßentyp (`roads.road`) der zugeordneten Straßenmittellinie für aus ihr abgeleitete, straßenbegleitende Radinfrastruktur.',
      parent_maxspeed:
        'Abgeleitete Höchstgeschwindigkeit der zugeordneten Straßenmittellinie für aus ihr abgeleitete, straßenbegleitende Radinfrastruktur.',
      adjoining_road:
        'Ein Indikator für die Gefährdung durch nahen Kfz-Verkehr: TILDA-Straßenklasse der relevanten Kfz-Straße (keine Aussage, ob der Weg zu dieser Straße gehört). Bei begleitenden Wegen die parallele Straße; bei Querungen die gequerte Straße. Primär, außer bei Querungen: OSM `is_sidepath:of`, über die TILDA-Straßenklassifikation gemappt (nur die `highway`-Klasse, ohne Untertags). Damit kann eine Kartierung die Schätzung überschreiben. `residential_priority_road` entsteht so nicht; der gröbere `:of`-Wert bleibt. Unbrauchbare `:of`-Werte (Tippfehler, Straßenname, `trunk`) fallen auf die Schätzung zurück. Bei Querungen immer nur die Schätzung (gequerte Straße), nie `:of`. Auch gesetzt, wenn der Weg selbstständig geführt ist.',
      adjoining_maxspeed:
        'TILDA-Höchstgeschwindigkeit (gleiche Ableitung wie roads.maxspeed: Tags, Zonen, Straßenklasse) der angrenzenden Straße; Maximum über die zugeordneten Straßensegmente der dominanten Klasse.',
      length:
        'Ein berechneter Wert für das OpenStreetMap-Straßensegment. Die Berechnung nutzt die Projektion EPSG:5243 und hat somit eine gute Genauigkeit für Deutschland.',
      prefix:
        'Kennzeichnet, aus welcher OSM-Tagfamilie die Radverkehrsinformationen für dieses Objekt extrahiert wurden. Der Wert wird im Processing gesetzt und beschreibt die verwendete Tag-Präfixlogik, nicht die Quelle im Sinne eines externen Datensatzes.',
      mapillary_coverage:
        'Basiert auf einer Analyse der Mapillary-Foto-Sequenzen der letzten ca. 2 Jahre, die mit den OSM-Wegen verschnitten wurden. Mehr unter https://tilda-geo.de/docs/mapillary-coverage',
      mapillary:
        'Mapillary-Bild-IDs (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_forward:
        'Mapillary-Bild-IDs in Linienrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_backward:
        'Mapillary-Bild-IDs in Gegenrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_traffic_sign:
        'Mapillary-Bild-IDs für Verkehrszeichen (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      route_relations: 'Routen und Netze, zu denen der Weg gehört.',
      offset:
        'Reiner Darstellungswert für den Kartenstil – empfohlener seitlicher Versatz in Metern. Die Geometrie bleibt auf der Straßen-Mittellinie; der Versatz wird ausschließlich visuell als `line-offset` angewendet und verändert die Daten nicht. Vorzeichen: positiv = links, negativ = rechts der Mittellinie. Der Betrag wird im Processing aus der halben Straßenbreite berechnet.',
    },
    values: {
      oneway: {
        assumed_no:
          'Keine explizite OSM-Angabe zur Verkehrsrichtung vorhanden. Aus Führungsform und Umfeld wird hier beide Richtungen als wahrscheinlich angenommen.',
        implicit_yes:
          'Keine explizite OSM-Angabe (`oneway` / `oneway:bicycle`). Aus der Führungsform abgeleitet (z. B. Schutzstreifen), nicht aus einem oneway-Tag gelesen.',
      },
      tunnel: {
        yes: 'Wege mit `tunnel=yes` und Gebäudedurchgänge mit `tunnel=building_passage`.',
      },
      covered: {
        covered:
          'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
      },
      traffic_sign: {
        never:
          'Wird aktuell intern für `category=cyclewayOnHighwayBetweenLanes` verwendet um klarzustellen, dass hier nie ein Verkehrszeichen zu erwarten ist.',
      },
      'traffic_sign:forward': {
        never:
          'Wird aktuell intern für `category=cyclewayOnHighwayBetweenLanes` verwendet um klarzustellen, dass hier nie ein Verkehrszeichen zu erwarten ist.',
      },
      'traffic_sign:backward': {
        never:
          'Wird aktuell intern für `category=cyclewayOnHighwayBetweenLanes` verwendet um klarzustellen, dass hier nie ein Verkehrszeichen zu erwarten ist.',
      },
    },
  },
  atlas_bikeroutes: {
    keys: {
      colours: 'Offizielle Farbe/Farben der Route',
    },
    values: {},
  },
  atlas_bikeSuitability: {
    keys: {
      length:
        'Ein berechneter Wert für das OpenStreetMap-Straßensegment. Die Berechnung nutzt die Projektion EPSG:5243 und hat somit eine gute Genauigkeit für Deutschland.',
      mapillary_coverage:
        'Basiert auf einer Analyse der Mapillary-Foto-Sequenzen der letzten ca. 2 Jahre, die mit den OSM-Wegen verschnitten wurden. Mehr unter https://tilda-geo.de/docs/mapillary-coverage',
      mapillary:
        'Mapillary-Bild-IDs (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_forward:
        'Mapillary-Bild-IDs in Linienrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_backward:
        'Mapillary-Bild-IDs in Gegenrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_traffic_sign:
        'Mapillary-Bild-IDs für Verkehrszeichen (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
    },
    values: {
      covered: {
        covered:
          'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
      },
    },
  },
  atlas_landuse: {
    keys: {
      landuse:
        'Enthält die zugelassenen `landuse`-Werte sowie ausgewählte `amenity`- und `leisure`-Flächen, die im Processing auf den `landuse`-Schlüssel normalisiert werden.',
    },
    values: {},
  },
  atlas_poiClassification: {
    keys: {},
    values: {
      type: {
        'amenity-fallback':
          'Auffangkategorie für seltene oder uneinheitliche amenity-Werte unterhalb des Volumen-Schwellenwertes.',
        'leisure-fallback':
          'Auffangkategorie für seltene oder uneinheitliche leisure-Werte unterhalb des Volumen-Schwellenwertes.',
        'shop-fallback':
          'Auffangkategorie für seltene oder uneinheitliche shop-Werte unterhalb des Volumen-Schwellenwertes.',
        'tourism-fallback':
          'Auffangkategorie für seltene oder uneinheitliche tourism-Werte unterhalb des Volumen-Schwellenwertes.',
      },
    },
  },
  atlas_roads: {
    keys: {
      highway: 'Wert des OSM-Tags `highway` ohne weitere Normalisierung.',
      name_ref: 'Enthält Kurznamen wie `A 100` oder `B 96`, übernommen aus dem OSM-Tag `ref`.',
      length:
        'Ein berechneter Wert für das OpenStreetMap-Straßensegment. Die Berechnung nutzt die Projektion EPSG:5243 und hat somit eine gute Genauigkeit für Deutschland.',
      mapillary_coverage:
        'Basiert auf einer Analyse der Mapillary-Foto-Sequenzen der letzten ca. 2 Jahre, die mit den OSM-Wegen verschnitten wurden. Mehr unter https://tilda-geo.de/docs/mapillary-coverage',
      mapillary:
        'Mapillary-Bild-IDs (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_forward:
        'Mapillary-Bild-IDs in Linienrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_backward:
        'Mapillary-Bild-IDs in Gegenrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_traffic_sign:
        'Mapillary-Bild-IDs für Verkehrszeichen (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      route_relations: 'Routen und Netze, zu denen der Weg gehört.',
    },
    values: {
      tunnel: {
        yes: 'Wege mit `tunnel=yes` und Gebäudedurchgänge mit `tunnel=building_passage`.',
      },
      covered: {
        covered:
          'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
      },
    },
  },
  atlas_roadsPathClasses: {
    keys: {
      length:
        'Ein berechneter Wert für das OpenStreetMap-Straßensegment. Die Berechnung nutzt die Projektion EPSG:5243 und hat somit eine gute Genauigkeit für Deutschland.',
      mapillary_coverage:
        'Basiert auf einer Analyse der Mapillary-Foto-Sequenzen der letzten ca. 2 Jahre, die mit den OSM-Wegen verschnitten wurden. Mehr unter https://tilda-geo.de/docs/mapillary-coverage',
      mapillary:
        'Mapillary-Bild-IDs (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_forward:
        'Mapillary-Bild-IDs in Linienrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_backward:
        'Mapillary-Bild-IDs in Gegenrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_traffic_sign:
        'Mapillary-Bild-IDs für Verkehrszeichen (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      route_relations: 'Routen und Netze, zu denen der Weg gehört.',
      adjoining_road:
        'Ein Indikator für die Gefährdung durch nahen Kfz-Verkehr: TILDA-Straßenklasse der relevanten Kfz-Straße (keine Aussage, ob der Weg zu dieser Straße gehört). Bei begleitenden Wegen die parallele Straße; bei Querungen die gequerte Straße. Primär, außer bei Querungen: OSM `is_sidepath:of`, über die TILDA-Straßenklassifikation gemappt (nur die `highway`-Klasse, ohne Untertags). Damit kann eine Kartierung die Schätzung überschreiben. `residential_priority_road` entsteht so nicht; der gröbere `:of`-Wert bleibt. Unbrauchbare `:of`-Werte (Tippfehler, Straßenname, `trunk`) fallen auf die Schätzung zurück. Bei Querungen immer nur die Schätzung (gequerte Straße), nie `:of`. Auch gesetzt, wenn der Weg selbstständig geführt ist.',
      adjoining_maxspeed:
        'TILDA-Höchstgeschwindigkeit (gleiche Ableitung wie roads.maxspeed: Tags, Zonen, Straßenklasse) der angrenzenden Straße; Maximum über die zugeordneten Straßensegmente der dominanten Klasse.',
    },
    values: {
      covered: {
        covered:
          'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
      },
    },
  },
  atlas_trafficSigns: {
    keys: {
      traffic_sign:
        'Im Format der OSM-Verkehrszeichen-Nomenklatur mit offiziellen Verkehrszeichen-IDs, z. B. `DE:240`.',
      mapillary:
        'Mapillary-Bild-IDs (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
    },
    values: {},
  },
  tilda_highwayAreas: {
    keys: {
      area: 'Fläche in Quadratmetern, aus der Geometrie.',
      mapillary_coverage:
        'Basiert auf einer Analyse der Mapillary-Foto-Sequenzen der letzten ca. 2 Jahre, die mit den OSM-Wegen verschnitten wurden. Mehr unter https://tilda-geo.de/docs/mapillary-coverage',
      mapillary:
        'Mapillary-Bild-IDs (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_forward:
        'Mapillary-Bild-IDs in Linienrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_backward:
        'Mapillary-Bild-IDs in Gegenrichtung (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
      mapillary_traffic_sign:
        'Mapillary-Bild-IDs für Verkehrszeichen (technisch bereinigt). Mehrere IDs sind als semikolongetrennte Liste möglich. Im Inspector wird pro ID ein Link erzeugt, z. B. `https://www.mapillary.com/app/?pKey=<ID>&focus=photo&z=15`.',
    },
    values: {
      covered: {
        covered:
          'Vollständig überdachte Wege (`covered=yes`) und Arkaden (`covered=arcade`, zur Seite hin offen).',
      },
      tunnel: {
        yes: 'Wege mit `tunnel=yes` und Gebäudedurchgänge mit `tunnel=building_passage`.',
      },
    },
  },
  tilda_parkings: {
    keys: {
      name: 'Name der Straße, übernommen vom längsten OSM-Way der Kante.',
      highway: 'Wert des OSM-Tags `highway` ohne weitere Normalisierung.',
      road: 'Art der Straße, an dem der Parkraum liegt.',
      capacity_left:
        'Summe der öffentlichen Stellplätze (`operator_type=public`) auf der linken Seite (relativ zur Kantenrichtung). Enthält Straßenparken und separat erfasste Flächen (z. B. `street_side`) nach dem Schnappen an die Bordsteinkante. Das Feld fehlt, wenn auf dieser Seite keine öffentlichen Stellplätze liegen.',
      capacity_right:
        'Summe der öffentlichen Stellplätze (`operator_type=public`) auf der rechten Seite (relativ zur Kantenrichtung). Enthält Straßenparken und separat erfasste Flächen (z. B. `street_side`) nach dem Schnappen an die Bordsteinkante. Das Feld fehlt, wenn auf dieser Seite keine öffentlichen Stellplätze liegen.',
      capacity_private_left:
        'Summe der privaten Stellplätze auf der linken Seite der Kante. Fehlt, wenn keine privaten Stellplätze vorhanden sind.',
      capacity_private_right:
        'Summe der privaten Stellplätze auf der rechten Seite der Kante. Fehlt, wenn keine privaten Stellplätze vorhanden sind.',
      operator_type_left:
        'Öffentlich oder privat. Die Gruppe mit mehr Stellplätzen auf der linken Straßenseite. Bei gleicher Summe gewinnt öffentlich. Bestimmt, welche Unterkategorie die Hilfslinie und die Zahl zeigt.',
      operator_type_right:
        'Öffentlich oder privat. Die Gruppe mit mehr Stellplätzen auf der rechten Straßenseite. Bei gleicher Summe gewinnt öffentlich. Bestimmt, welche Unterkategorie die Hilfslinie und die Zahl zeigt.',
      condition_category_left:
        'Dominantes Beschränkungs-Token der gewinnenden Operator-Gruppe auf der linken Straßenseite. Nur zur Darstellung.',
      condition_category_right:
        'Dominantes Beschränkungs-Token der gewinnenden Operator-Gruppe auf der rechten Straßenseite. Nur zur Darstellung.',
      parking_left:
        'Dominanter `parking`-Wert der gewinnenden Operator-Gruppe auf der linken Straßenseite. `missing` bedeutet hier, dass auf dieser Seite keine Stellplätze der gewinnenden Gruppe liegen, nicht dass OSM-Daten fehlen.',
      parking_right:
        'Dominanter `parking`-Wert der gewinnenden Operator-Gruppe auf der rechten Straßenseite. `missing` bedeutet hier, dass auf dieser Seite keine Stellplätze der gewinnenden Gruppe liegen, nicht dass OSM-Daten fehlen.',
      surface_left:
        'Dominanter `surface`-Wert der gewinnenden Operator-Gruppe auf der linken Straßenseite. Nur zur Darstellung im Stil „Oberfläche“.',
      surface_right:
        'Dominanter `surface`-Wert der gewinnenden Operator-Gruppe auf der rechten Straßenseite. Nur zur Darstellung im Stil „Oberfläche“.',
      way_ids:
        'JSON-Array der OSM-Way-IDs, aus denen diese Kante zusammengesetzt ist. Nicht Teil der Kanten-ID.',
      way_reversed:
        'JSON-Array analog zu `way_ids`. Pro Way, ob die OSM-Digitization der Kantenrichtung entgegengesetzt ist.',
      start_node: 'OSM-Node-ID am Anfang der Kante. Zusammen mit `end_node` die Objekt-ID.',
      end_node: 'OSM-Node-ID am Ende der Kante. Zusammen mit `start_node` die Objekt-ID.',
      capacity: 'Geschätzte oder explizit erfasste Anzahl von Stellplätzen.',
      area: 'Fläche des durch parkende Fahrzeuge auf diesem Parkraumabschnitt belegten Raumes in Quadratmetern.',
      angle:
        'Drehung der Beschriftung in Grad (im Uhrzeigersinn, 0 = Osten), entlang der Linie (Parklinie bzw. Kante) und so gewendet, dass der Text nie auf dem Kopf steht (−90 bis 90). Nur zur Darstellung.',
      parking: 'Lage oder Art des Parkraums im Straßenland.',
      capacity_source: 'Herkunft der Stellplatzanzahl inklusive Schätz- oder Umverteilungslogik.',
      orientation: 'Ausrichtung der Fahrzeuge im Straßenland zur Verkehrsrichtung.',
      condition_category_primary:
        'Der für die Darstellung wichtigste Wert aus `condition_category`. Reihenfolge: Sonderparkplätze (Behinderte, Taxi, Ladezone, E-Laden, Carsharing) vor Park- und Haltverboten, dann private/eingeschränkte Flächen, dann Höchstparkdauer vor Bewirtschaftung. Nur zur Darstellung; fachlich gilt `condition_category`.',
      staggered:
        'Besondere Merkmale zur Parkweise, insbesondere bei alternierendem/versetztem Parken auf Fahrbahnen, die zu schmal sind um auf beiden Seiten gleichzeitig zu parken, keine Markierungen und Beschilderungen aufweisen, die das Parken regeln und auf denen gewöhnlich wechselseitig abschnittsweise auf der einen oder anderen Straßenseite geparkt wird oder geparkt werden kann.',
      length:
        'Ein berechneter Wert für das OpenStreetMap-Straßensegment. Die Berechnung nutzt die Projektion EPSG:5243 und hat somit eine gute Genauigkeit für Deutschland.',
      source: 'Datenquelle der Parkraumgeometrie aus OpenStreetMap.',
      geom_sources:
        'Interne Hilfswerte. Semikolonseparierte Liste der OSM-IDs die für eine Geometrie verwendet wurden.',
      tag_sources:
        'Interne Hilfswerte. Semikolonseparierte Liste der OSM-IDs aus denen die OSM-Tags abgeleitet wurden.',
      road_name: 'Name der Straße, an dem der Parkraum liegt.',
      road_oneway: 'Verkehrsrichtung der Straße, an dem der Parkraum liegt.',
      road_width: 'Breite der Fahrbahn, an dem der Parkraum liegt.',
      side: 'Seite des Parkraums relativ zur Linienrichtung der OSM-Geometrie.',
      surface: 'Oberflächenbelag des Parkraumabschnitts.',
      direction: 'Vorgesehene oder ausgeschilderte Fahrzeugrichtung beim Einparken.',
      location: 'Besondere Lagemerkmale des Parkraums im Straßenland.',
      zone: 'Parkzonennummer oder -bezeichnung entsprechend der lokalen Parkraumbewirtschaftung bei Stellplätzen, die nur mit einem entsprechenden Parkrausweis genutzt werden dürfen. Sind (insbesondere an Zonengrenzen) mehrere Parkzonen berechtigt, sind diese üblicherweise als semikolongetrennte Liste aufgeführt.',
      reason: 'Angabe eines Grundes bei Nicht-Parken.',
      mapillary: 'Mapillary-Foto-ID für dieses Feature.',
      traffic_sign: 'Verkehrszeichennummer, mit der dieses Feature ausgeschildert ist.',
      _staggered_maneuvering_loss:
        'Interner Wert aus der Kapazitätsberechnung bei alternierendem Parken',
      _staggered_original_capacity:
        'Interner Zwischenwert vor Anwendung der alternierenden-Parken-Logik',
    },
    values: {
      condition_category_left: {
        invalid:
          'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
      },
      condition_category_right: {
        invalid:
          'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
      },
      condition_category: {
        invalid:
          'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
      },
      condition_category_primary: {
        invalid:
          'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
      },
      staggered: {
        yes: 'Auf diesem Abschnitt ist die Fahrbahn zu schmal, um auf beiden Seiten gleichzeitig zu parken. Es gibt keine Markierungen oder Schilder, die das Parken regeln. Häufig entwickeln sich örtliche Konventionen, in welchen Bereichen auf welcher Seite geparkt wird. In die Kapazitätsberechnung fließt das ein: Die Kapazität wird um 50% reduziert (da nur eine Seite genutzt werden kann) und zusätzlich wird für jeden 60m-Abschnitt ein Manövrierraumverlust von 10m (≈1,9 Fahrzeugplätze) abgezogen, da beim Seitenwechsel Manövrierraum benötigt wird. Diese Angaben basieren auf Erfahrungswerten und können lediglich eine Schätzung des tatsächlichen Parkgeschehens abbilden.',
      },
    },
  },
  tilda_parkings_cutouts: {
    keys: {
      source:
        'In der Export-Tabelle `parkings_cutouts` erscheinen nur Stanzungen, deren `source` nicht parking_roads, separate_parking_areas oder separate_parking_points ist.',
      buffer_radius: 'Radius der Stanzung in Metern.',
      radius:
        'Radius eines Puffers in Metern, u. a. an Kreuzungs-Ecken (Bordsteinschnittpunkte) und eUVM-Punkten.',
      geom_sources: 'Interne Aufschlüsselung der für die Geometrie verwendeten Quellen (JSON).',
      tag_sources: 'Interne Aufschlüsselung der OSM-Tag-Herkunft (JSON).',
    },
    values: {},
  },
  tilda_parkings_no: {
    keys: {
      parking: 'Lage oder Art des Parkraums im Straßenland.',
      reason: 'Angabe eines Grundes bei Nicht-Parken.',
      condition_category_primary:
        'Der für die Darstellung wichtigste Wert aus `condition_category`. Reihenfolge: Sonderparkplätze (Behinderte, Taxi, Ladezone, E-Laden, Carsharing) vor Park- und Haltverboten, dann private/eingeschränkte Flächen, dann Höchstparkdauer vor Bewirtschaftung. Nur zur Darstellung; fachlich gilt `condition_category`.',
      capacity: 'Geschätzte oder explizit erfasste Anzahl von Stellplätzen.',
      capacity_source: 'Herkunft der Stellplatzanzahl inklusive Schätz- oder Umverteilungslogik.',
      orientation: 'Ausrichtung der Fahrzeuge im Straßenland zur Verkehrsrichtung.',
      staggered:
        'Besondere Merkmale zur Parkweise, insbesondere bei alternierendem/versetztem Parken auf Fahrbahnen, die zu schmal sind um auf beiden Seiten gleichzeitig zu parken, keine Markierungen und Beschilderungen aufweisen, die das Parken regeln und auf denen gewöhnlich wechselseitig abschnittsweise auf der einen oder anderen Straßenseite geparkt wird oder geparkt werden kann.',
      source: 'Datenquelle der Parkraumgeometrie aus OpenStreetMap.',
      geom_sources:
        'Interne Hilfswerte. Semikolonseparierte Liste der OSM-IDs die für eine Geometrie verwendet wurden.',
      tag_sources:
        'Interne Hilfswerte. Semikolonseparierte Liste der OSM-IDs aus denen die OSM-Tags abgeleitet wurden.',
      road: 'Art der Straße, an dem der Parkraum liegt.',
      road_name: 'Name der Straße, an dem der Parkraum liegt.',
      road_oneway: 'Verkehrsrichtung der Straße, an dem der Parkraum liegt.',
      road_width: 'Breite der Fahrbahn, an dem der Parkraum liegt.',
      side: 'Seite des Parkraums relativ zur Linienrichtung der OSM-Geometrie.',
      area: 'Fläche des durch parkende Fahrzeuge auf diesem Parkraumabschnitt belegten Raumes in Quadratmetern.',
      surface: 'Oberflächenbelag des Parkraumabschnitts.',
      direction: 'Vorgesehene oder ausgeschilderte Fahrzeugrichtung beim Einparken.',
      location: 'Besondere Lagemerkmale des Parkraums im Straßenland.',
      zone: 'Parkzonennummer oder -bezeichnung entsprechend der lokalen Parkraumbewirtschaftung bei Stellplätzen, die nur mit einem entsprechenden Parkrausweis genutzt werden dürfen. Sind (insbesondere an Zonengrenzen) mehrere Parkzonen berechtigt, sind diese üblicherweise als semikolongetrennte Liste aufgeführt.',
      mapillary: 'Mapillary-Foto-ID für dieses Feature.',
      traffic_sign: 'Verkehrszeichennummer, mit der dieses Feature ausgeschildert ist.',
      _staggered_maneuvering_loss:
        'Interner Wert aus der Kapazitätsberechnung bei alternierendem Parken',
      _staggered_original_capacity:
        'Interner Zwischenwert vor Anwendung der alternierenden-Parken-Logik',
    },
    values: {
      condition_category: {
        invalid:
          'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
      },
      condition_category_primary: {
        invalid:
          'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
      },
      staggered: {
        yes: 'Auf diesem Abschnitt ist die Fahrbahn zu schmal, um auf beiden Seiten gleichzeitig zu parken. Es gibt keine Markierungen oder Schilder, die das Parken regeln. Häufig entwickeln sich örtliche Konventionen, in welchen Bereichen auf welcher Seite geparkt wird. In die Kapazitätsberechnung fließt das ein: Die Kapazität wird um 50% reduziert (da nur eine Seite genutzt werden kann) und zusätzlich wird für jeden 60m-Abschnitt ein Manövrierraumverlust von 10m (≈1,9 Fahrzeugplätze) abgezogen, da beim Seitenwechsel Manövrierraum benötigt wird. Diese Angaben basieren auf Erfahrungswerten und können lediglich eine Schätzung des tatsächlichen Parkgeschehens abbilden.',
      },
    },
  },
  tilda_parkings_off_street: {
    keys: {
      category: 'Kategorie der Parkmöglichkeit.',
      parking: 'Typ der Parkmöglichkeit.',
      capacity: 'Geschätzte oder explizit erfasste Anzahl von Stellplätzen.',
      capacity_source: 'Herkunft der Stellplatzanzahl inklusive Schätz- oder Umverteilungslogik.',
      condition_category_primary:
        'Der für die Darstellung wichtigste Wert aus `condition_category`. Reihenfolge: Sonderparkplätze (Behinderte, Taxi, Ladezone, E-Laden, Carsharing) vor Park- und Haltverboten, dann private/eingeschränkte Flächen, dann Höchstparkdauer vor Bewirtschaftung. Nur zur Darstellung; fachlich gilt `condition_category`.',
      area: 'Fläche in Quadratmetern.',
      surface: 'Oberflächenbelag des Parkraumabschnitts.',
      orientation: 'Ausrichtung der Fahrzeuge im Straßenland zur Verkehrsrichtung.',
      location: 'Besondere Lagemerkmale des Parkraums im Straßenland.',
      zone: 'Parkzonennummer oder -bezeichnung entsprechend der lokalen Parkraumbewirtschaftung bei Stellplätzen, die nur mit einem entsprechenden Parkrausweis genutzt werden dürfen. Sind (insbesondere an Zonengrenzen) mehrere Parkzonen berechtigt, sind diese üblicherweise als semikolongetrennte Liste aufgeführt.',
      mapillary: 'Mapillary-Foto-ID für dieses Feature.',
      traffic_sign: 'Verkehrszeichennummer, mit der dieses Feature ausgeschildert ist.',
    },
    values: {
      condition_category: {
        invalid:
          'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
      },
      condition_category_primary: {
        invalid:
          'Mindestens ein `*:conditional`-Tag ist syntaktisch fehlerhaft (z. B. unvollständige Klammern). Die tatsächliche Beschränkung ist daher unbekannt; der Tag ist in `parking_errors` gelistet und sollte in OSM korrigiert werden.',
      },
    },
  },
} as const satisfies Record<
  string,
  { keys: Record<string, string>; values: Record<string, Record<string, string>> }
>

export default data
